import React, { useContext } from 'react'
import { isEmpty, startCase } from 'lodash'
import dayjs from 'dayjs'
import { AiFillEye } from 'react-icons/ai'
import { useTranslation } from 'react-i18next'
import { BsArrowUpShort } from 'react-icons/bs'
import AuthContext from 'context/AuthContext'
import { NavLink } from 'react-router-dom'
import classNames from 'classnames'

const Table = ({
  users,
  getAllUser,
  // handelEdit,
  handleUserView,
  handleAuctionView,
  handlePropertyView,
  // user,
  paginationObj,
  sort,
  setSort
  // manager
}) => {
  const { t } = useTranslation()
  const { config } = useContext(AuthContext)

  return (
    <div className='p-3'>
      <div className='overflow-x-auto relative 
 border'>
        <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
          <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
            <tr>
              <th scope='col' className='py-3 px-6'>
                #
              </th>
              <th scope='col' className='py-3 px-6 text-center'>
                <div className='text-center'>
                  <span>Full name</span>
                </div>
              </th>
              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
                onClick={() => {
                  if (
                    sort.sort_key === 'transactionId' &&
                    sort.sort_type === 'asc'
                  ) {
                    setSort({
                      sort_key: 'transactionId',
                      sort_type: 'desc'
                    })
                  } else {
                    setSort({
                      sort_key: 'transactionId',
                      sort_type: 'asc'
                    })
                  }
                }}
              >
                <div className='flex '>
                  <span>Transaction ID</span>
                  <span>
                    {sort.sort_key === 'transactionId' &&
                      sort.sort_type === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                    {sort.sort_key === 'transactionId' &&
                      sort.sort_type === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                  </span>
                </div>
              </th>
              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
                onClick={() => {
                  if (
                    sort.sort_key === 'createdAt' &&
                    sort.sort_type === 'asc'
                  ) {
                    setSort({
                      sort_key: 'createdAt',
                      sort_type: 'desc'
                    })
                  } else {
                    setSort({
                      sort_key: 'createdAt',
                      sort_type: 'asc'
                    })
                  }
                }}
              >
                <div className='flex justify-left'>
                  <span>Transaction Date</span>
                  <span>
                    {sort.sort_key === 'createdAt' &&
                      sort.sort_type === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                    {sort.sort_key === 'createdAt' &&
                      sort.sort_type === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                  </span>
                </div>
              </th>
              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
                onClick={() => {
                  if (
                    sort.sort_key === 'transaction_amount' &&
                    sort.sort_type === 'asc'
                  ) {
                    setSort({
                      sort_key: 'transaction_amount',
                      sort_type: 'desc'
                    })
                  } else {
                    setSort({
                      sort_key: 'transaction_amount',
                      sort_type: 'asc'
                    })
                  }
                }}
              >
                <div className='flex justify-left'>
                  <span>Transaction Amount</span>
                  <span>
                    {sort.sort_key === 'transaction_amount' &&
                      sort.sort_type === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                    {sort.sort_key === 'transaction_amount' &&
                      sort.sort_type === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                  </span>
                </div>
              </th>
              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
                onClick={() => {
                  if (
                    sort.sort_key === 'createdAt' &&
                    sort.sort_type === 'asc'
                  ) {
                    setSort({
                      sort_key: 'createdAt',
                      sort_type: 'desc'
                    })
                  } else {
                    setSort({
                      sort_key: 'createdAt',
                      sort_type: 'asc'
                    })
                  }
                }}
              >
                <div className='flex justify-end'>
                  <span>{t('O_CREATED_AT')}</span>
                  <span>
                    {sort.sort_key === 'createdAt' &&
                      sort.sort_type === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                    {sort.sort_key === 'createdAt' &&
                      sort.sort_type === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                  </span>
                </div>
              </th>
              <th scope='col' className='py-3 px-6 text-center'>
                <div className='text-right'>
                  <span>Type</span>
                </div>
              </th>
              <th scope='col' className='py-3 px-6 text-center'>
                <div className='text-center'>
                  <span>Auction</span>
                </div>
              </th>

              <th scope='col' className='py-3 px-6 text-center'>
                {t('O_ACTION')}
              </th>
            </tr>
          </thead>
          <tbody>
            {users &&
              users?.map((item, i) => (
                <tr
                  key={i}
                  className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                >
                  <th
                    scope='row'
                    className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                  >
                    {i + 1 + 10 * (paginationObj?.page - 1)}
                  </th>
                  <td className='py-2 px-2 border-r'>
                    {item?.userType === 'company'
                      ? startCase(item?.company?.name)
                      : startCase(
                          item?.user?.firstName + ' ' + item?.user?.lastName
                        )}{' '}
                  </td>
                  <td className='py-2 px-2 border-r'>
                    {`${item?.transactionId}`}{' '}
                  </td>
                  <td className='py-2 px-2 border-r'>
                    {dayjs(item?.createdAt).format('DD-MM-YYYY hh:mm A')}
                  </td>
                  <td className='py-2 px-2 border-r '>
                    <span
                      className={classNames(
                        'rounded-md p-2 inline-block text-center',
                        {
                          'bg-yellow-200 text-yellow-500':
                            item?.transactionType === 'subscription',
                          'bg-green-200 text-green-700':
                            item?.transactionType === 'biddingFees'
                        }
                      )}
                    >
                      {item?.transactionAmount} {config.currency}
                    </span>
                  </td>
                  <td className='py-2 px-2 border-r text-right'>
                    {' '}
                    {dayjs(item?.createdAt).format('DD-MM-YYYY hh:mm A')}{' '}
                  </td>
                  <td className='py-2 px-2 border-r text-center'>
                    <span
                      className={classNames({
                        'text-yellow-500':
                          item?.transactionType === 'subscription',
                        'text-green-500':
                          item?.transactionType === 'biddingFees'
                      })}
                    >
                      {startCase(item?.transactionType)}
                    </span>
                  </td>
                  <td className='py-2 px-2 border-r text-center '>
                    {item?.transactionType === 'biddingFees' && (
                      <NavLink
                        className={
                          'bg-blue-900 hover:bg-blue-800 rounded-lg p-2 text-white pl-4 pr-4'
                        }
                        to={`/auction/view/${item?.propertyId}`}
                        state={{ item, propertyId: item?.propertyId }}
                      >
                        Details
                      </NavLink>
                      // <span
                      //   className='cursor-pointer'
                      //   onClick={() => handleAuctionView(item)}
                      // >
                      //   details
                      // </span>
                    )}
                  </td>
                  {/* <td className='py-2 px-2 border-r text-center ' onClick={() => handlePropertyView(item)}>
										{item?.transactionType === 'subscription' && (
											<NavLink
												className={'bg-blue-900 hover:bg-blue-800 rounded-lg p-2 text-white pl-4 pr-4'}
												to={`/properties/view/${item?.propertyId}`}
												state={{ item, propertyId: item?.propertyId }}
											>
												Details
											</NavLink>
										)}
									</td> */}

                  <td className='py-2 px-2 border-l'>
                    <div className=''>
                      <ul className='flex justify-center'>
                        <li
                          onClick={() => handleUserView(item)}
                          className='px-2 py-2 hover:bg-white hover:text-LightBlue'
                        >
                          <button title={t('O_VIEW_USER')}>
                            {' '}
                            <AiFillEye className='cursor-pointer w-5 h-5 text-slate-600' />{' '}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(users) && (
              <tr className='bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700'>
                <td className='py-2 px-2 border-r' colSpan={8}>
                  {t('O_NO_RECORD_FOUND')}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Table
